/* src/modules/dashboard/components/LineGraph/styles.js */

export default theme => ({
  container: {
    padding: theme.spacing.unit * 2,
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing.unit * 5,
  },
  textFields: {
    display: 'flex',
    flexDirection: 'row',
  },
  textField: {
    width: 150,
  },
  startDateTextField: {
    width: 150,
    marginRight: theme.spacing.unit,
  },
  'formControl-Type': {
    marginLeft: theme.spacing.unit,
  },
});



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/LineGraph/styles.js